{
  "about.blocks": "Moderatit servers",
  "about.contact": "Contack:",
  "about.disclaimer": "Mastodon is free, open-soorced saftware, an a trademairk o Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Raison no available",
  "about.domain_blocks.preamble": "On the hail, Mastodon lats ye view content frae an interack wi uisers fae onie ither server in the fediverse.",
  "about.domain_blocks.silenced.explanation": "Ye'll generally no see profiles an content frae this server, unless ye explicitly luik it up or opt intae it bi follaein.",
  "about.domain_blocks.silenced.title": "Limitit",
  "about.domain_blocks.suspended.explanation": "Nae data frae this server wull bi processed, stored or exchynged, makkin onie interaction or communication wi uisers frae this server no possible.",
  "about.domain_blocks.suspended.title": "Suspendit",
  "about.not_available": "This information haesnae been made available on this server.",
  "about.powered_by": "Decentralised social media pooert bi {mastodon}",
  "about.rules": "Server rules",
  "account.add_or_remove_from_list": "Add or Remuive frae lists",
  "account.badges.bot": "Bot",
  "account.badges.group": "Group",
  "account.block": "Dingie @{name}",
  "account.block_domain": "Dingie domain {domain}",
  "account.blocked": "Dingied",
  "account.cancel_follow_request": "Resile follae requeest",
  "account.disable_notifications": "Stap notifyin me whan @{name} posts",
  "account.edit_profile": "Edit profile",
  "account.enable_notifications": "Notify me whan @{name} posts",
  "account.endorse": "Shaw oan profile",
  "account.follow": "Follae",
  "account.followers": "Follaers",
  "account.followers.empty": "Naebody follaes this uiser yit.",
  "account.following": "Follaein",
  "account.follows.empty": "This uiser disnae follae oniebody yit.",
  "account.go_to_profile": "Gang tae profile",
  "account.hide_reblogs": "Dinnae shaw heezes fae @{name}",
  "account.joined_short": "Jynt",
  "account.languages": "Chynge subscribed leids",
  "account.link_verified_on": "Ainership o this link wis checked on {date}",
  "account.locked_info": "This accoont privacy status is snibbed. The ainer picks wha kin follae them bi haun.",
  "account.media": "Media",
  "account.mention": "Menshie@{name}",
  "account.moved_to": "{name} haes sayed thit their new accoont is noo:",
  "account.mute": "Wheesht@{name}",
  "account.muted": "Whesht",
  "account.open_original_page": "Open the furst page",
  "account.posts": "Posts",
  "account.report": "Clype @{name}",
  "account.share": "Share @{name}'s profile",
  "account.show_reblogs": "Shaw heezes frae @{name}",
  "account.unblock": "Undingie @{name}",
  "account.unblock_domain": "Undingie domain {domain}",
  "account.unblock_short": "Undingie",
  "account.unendorse": "Dinnae pit on profile",
  "account.unfollow": "Unfollae",
  "account.unmute": "Unwheesht @{name}",
  "account.unmute_short": "Unwheesht",
  "account_note.placeholder": "Chap tae eik note",
  "admin.dashboard.daily_retention": "Uiser retention rate bi day efter signin-up",
  "admin.dashboard.monthly_retention": "Uiser retention rate bi month efter signin-up",
  "admin.dashboard.retention.average": "Average",
  "admin.dashboard.retention.cohort": "Signin-up month",
  "admin.dashboard.retention.cohort_size": "New uisers",
  "alert.rate_limited.message": "Please hae anither shot efter {retry_time, time, medium}.",
  "alert.rate_limited.title": "Rate limitit",
  "alert.unexpected.message": "A error thit wisnae expectit happent.",
  "alert.unexpected.title": "Crivvens!",
  "announcement.announcement": "Annooncement",
  "attachments_list.unprocessed": "(No processed)",
  "audio.hide": "Stow audio",
  "block_modal.remote_users_caveat": "We will ask the server {domain} tae respect yer decision. Awtho mind compliance isnae a guarantee, sin some servers may haundle blocks differently. Public posts may yet be visible tae non-loggit-in uisers.",
  "block_modal.they_will_know": "Thay can see that they're blockit.",
  "block_modal.title": "Block uiser?",
  "boost_modal.combo": "Ye kin chap {combo} tae dingie this neist tim",
  "bundle_column_error.copy_stacktrace": "Copy error report",
  "bundle_column_error.error.body": "The requestit page cuidnae be rennert. Hit cuid be doon tae a bug in wir code, or a brooser compatability issue.",
  "bundle_column_error.error.title": "Aw naw!",
  "bundle_column_error.network.body": "There wis a error whan gaun tae load this page. This cuid be doon tae a temporary snaffle wi yer internet connexion or wi this server.",
  "bundle_column_error.network.title": "Netwirk error",
  "bundle_column_error.retry": "Gie it anither shot",
  "bundle_column_error.return": "Gae back hame",
  "bundle_column_error.routing.body": "The requestit page cuidnae be fun. Are ye shair thit the URL in the addres baur is richt?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Shut",
  "bundle_modal_error.retry": "Gie it anither shot",
  "closed_registrations.other_server_instructions": "Seein Mastodon is decentralized ye kin mak a accoont on anither server an stull interact wi this ane.",
  "closed_registrations_modal.description": "Makkin a accoont on {domain} isnae possible the noo, but mind ye dinnae need a accoont on {domain} specific for tae uise Mastodon.",
  "closed_registrations_modal.find_another_server": "Fin anither server",
  "closed_registrations_modal.preamble": "Mastodon is decentralized, sae nae maitter whaur ye mak yer accoont, ye'll can follae an interack wi oniebody on this server. Ye kin even sel-host it!",
  "closed_registrations_modal.title": "Signin up on Mastodon",
  "column.about": "Aboot",
  "column.blocks": "Dingied uisers",
  "column.bookmarks": "Buikmairks",
  "column.community": "Local timeline",
  "column.directory": "Broose profiles",
  "column.domain_blocks": "Dingied domains",
  "column.follow_requests": "Follae requests",
  "column.home": "Hame",
  "column.lists": "Lists",
  "column.mutes": "Wheesht uisers",
  "column.notifications": "Notes",
  "column.pins": "Preenit posts",
  "column.public": "Federatit timeline",
  "column_back_button.label": "Back",
  "column_header.hide_settings": "Hide settins",
  "column_header.moveLeft_settings": "Shift column tae the left",
  "column_header.moveRight_settings": "Shift column tae the richt",
  "column_header.pin": "Preen",
  "column_header.show_settings": "Shaw settins",
  "column_header.unpin": "Unpreen",
  "community.column_settings.local_only": "Local ainly",
  "community.column_settings.media_only": "Media ainly",
  "community.column_settings.remote_only": "Remote ainly",
  "compose.language.change": "Chynge Leid",
  "compose.language.search": "Seirch leids...",
  "compose.published.body": "Post published.",
  "compose.saved.body": "Post saved.",
  "compose_form.direct_message_warning_learn_more": "Lairn mair",
  "compose_form.encryption_warning": "Posts on Mastodon isnae en-tae-en encryptit. Dinnae share onie sensitive information ower Mastodon.",
  "compose_form.hashtag_warning": "This post willnae be listit under ony hashtag fir it is unlistit. Only public posts can be searched by hashtag.",
  "compose_form.lock_disclaimer": "Yer accoont isnae {locked}. Awbody kin follae ye for tae luik at yer follaer-ainly posts.",
  "compose_form.lock_disclaimer.lock": "lockit",
  "compose_form.placeholder": "Whit's on yer mind?",
  "compose_form.poll.duration": "Poll lenth",
  "compose_form.poll.switch_to_multiple": "Chynge poll tae alloo multiple chyces",
  "compose_form.poll.switch_to_single": "Chynge poll tae alloo fir a single chyce",
  "compose_form.spoiler.marked": "Tak aff the content warnin",
  "compose_form.spoiler.unmarked": "Pit on a content warnin",
  "compose_form.spoiler_placeholder": "Content warnin (optional)",
  "confirmation_modal.cancel": "Stap",
  "confirmations.block.confirm": "Dingie",
  "confirmations.delete.confirm": "Delete",
  "confirmations.delete.message": "Ye shair thit ye'r wantin tae delete this post?",
  "confirmations.delete_list.confirm": "Delete",
  "confirmations.delete_list.message": "Ye shair thit ye'r wantin fir tae delete this post fir ever?",
  "confirmations.discard_edit_media.confirm": "Fling awa",
  "confirmations.discard_edit_media.message": "Ye'v chynges tae the media description or preview thit ye'v no saved, fling them awa onie weys?",
  "confirmations.logout.confirm": "Log oot",
  "confirmations.logout.message": "Ye shair thit ye'r wantin tae log oot?",
  "confirmations.mute.confirm": "Wheesht",
  "confirmations.redraft.confirm": "Delete an stert anew",
  "confirmations.unfollow.confirm": "Unfollae",
  "conversation.delete": "Delete the conversation",
  "conversation.mark_as_read": "Mairk as seen",
  "conversation.open": "Luik at conversation",
  "conversation.with": "Wi {names}",
  "copypaste.copied": "Copied",
  "directory.federated": "Fae a kent fediverse",
  "directory.local": "Fae {domain} ainly",
  "directory.new_arrivals": "New arrivals",
  "directory.recently_active": "Active recent",
  "disabled_account_banner.account_settings": "Accoont settins",
  "disabled_account_banner.text": "Yer accoont {disabledAccount} is disabilt the noo.",
  "dismissable_banner.community_timeline": "Here the maist recent public posts fae fowk thit's accoonts is hostit bi {domain}.",
  "dismissable_banner.dismiss": "Pit awa",
  "embed.instructions": "Embed this post on yer wabsteid bi copyin the code ablow.",
  "embed.preview": "Here whit it'll luik lik:",
  "emoji_button.activity": "Activity",
  "emoji_button.clear": "Claer",
  "emoji_button.custom": "Custom",
  "emoji_button.flags": "Flags",
  "emoji_button.food": "Fid & drink",
  "emoji_button.label": "Pit in emoji",
  "emoji_button.nature": "Naiture",
  "emoji_button.not_found": "Nae matchin emoji fun",
  "emoji_button.objects": "Objecks",
  "emoji_button.people": "Fowk",
  "emoji_button.recent": "Maist aften uised",
  "emoji_button.search": "Seirch...",
  "emoji_button.search_results": "Seirch results",
  "emoji_button.symbols": "Symbols",
  "emoji_button.travel": "Traivel & steidins",
  "empty_column.account_suspended": "Accoont suspendit",
  "empty_column.account_timeline": "Nae posts here!",
  "empty_column.account_unavailable": "Profile isnae available",
  "empty_column.blocks": "Ye huvnae dingied onie uisers yit.",
  "empty_column.bookmarked_statuses": "Ye dinnae hae onie buikmairkt posts yit. Efter ye buikmairk ane, it'll shaw up here.",
  "empty_column.community": "The loval timeline is toum. Screive socht public fir tae get gaun!",
  "empty_column.domain_blocks": "There nae dingied domains yit.",
  "empty_column.explore_statuses": "Naethin is trendin the noo. Check back efter!",
  "empty_column.follow_requests": "Ye dinnae hae onie follaer requests yit. Whan ye get ane, it'll shaw up here.",
  "empty_column.hashtag": "There naethin in this hashtag yit.",
  "empty_column.home": "Yer hame timeline is toum! Follae mair fowk fir tae full it up.",
  "empty_column.list": "There naethin in this list yit. Whan memmers o this list publish new posts, ye'll see them here.",
  "empty_column.mutes": "Ye'v no wheesht onie uisers yit.",
  "empty_column.notifications": "Ye dinnae hae onie notes yit. Whan ither fowk interacks wi ye, ye'll see it here.",
  "empty_column.public": "There naethin here! Scrieve socht public, or follae uisers fae ither servers fir tae full it up",
  "error.unexpected_crash.explanation": "Doon tae a bug in wir code or a brooser compatibility maitter, this page cuidnae get displayed richt.",
  "error.unexpected_crash.explanation_addons": "This page cannae be displayit richt. This error is maist lik tae be doon tae a brooser add-on or autimatic owersettin tools.",
  "error.unexpected_crash.next_steps": "Gie refreshin the page a shot. Gin thon disnae help ye, ye kin mibbie stull be able tae uise Mastodon throu anither brooser or native app.",
  "error.unexpected_crash.next_steps_addons": "Try oot pittin them aff an rejiggin the page. Gin thon disnae wirk, ye kin mibbie uise Mastodon on a different brooser or native app.",
  "errors.unexpected_crash.copy_stacktrace": "Copy stacktrace tae yer clipboord",
  "errors.unexpected_crash.report_issue": "Sen in a issue",
  "filter_modal.added.context_mismatch_explanation": "This filter caitegory disnae apply tae the context thit ye'v uised tae access this post. Gin ye'r wantin the post tae be filtert in this context tae, ye'll hae tae edit the filter.",
  "filter_modal.added.context_mismatch_title": "Context disnae match!",
  "filter_modal.added.expired_explanation": "This filter caitegory haes expirit, ye'll hae tae chynge the expiration date fir it tae apply.",
  "filter_modal.added.expired_title": "Expirit filter!",
  "filter_modal.added.review_and_configure": "Tae luik ower an configure this filter caitegort mair, awa tae the {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Filter settins",
  "filter_modal.added.settings_link": "settins page",
  "filter_modal.added.short_explanation": "This post haes been eikit tae the follaein filter caitegory: {title}.",
  "filter_modal.added.title": "Filter pit on!",
  "filter_modal.select_filter.context_mismatch": "disnae apply tae this context",
  "filter_modal.select_filter.expired": "expirit",
  "filter_modal.select_filter.prompt_new": "New caitegory: {name}",
  "filter_modal.select_filter.search": "Seirch or mak",
  "filter_modal.select_filter.subtitle": "Uise a awriddy existin caitegory or mak a new ane",
  "filter_modal.select_filter.title": "Filter this post",
  "filter_modal.title.status": "Filter a post",
  "follow_request.authorize": "Gie permission",
  "follow_request.reject": "Dingie",
  "follow_requests.unlocked_explanation": "Tho yer accoont isnae snibbed, the {domain} staff thocht ye'd mibbie want tae review follae requests fae thir accoonts bi haun.",
  "footer.about": "Aboot",
  "footer.directory": "Profiles directory",
  "footer.get_app": "Get the app",
  "footer.keyboard_shortcuts": "Keyboord shortcuts",
  "footer.privacy_policy": "Privacy policy",
  "footer.source_code": "View the soorce code",
  "generic.saved": "Saved",
  "getting_started.heading": "Gettin stertit",
  "hashtag.column_header.tag_mode.all": "an {additional}",
  "hashtag.column_header.tag_mode.any": "or {additional}",
  "hashtag.column_header.tag_mode.none": "athoot {additional}",
  "hashtag.column_settings.select.no_options_message": "Nae suggestions fun",
  "hashtag.column_settings.select.placeholder": "Pit in hashtags…",
  "hashtag.column_settings.tag_mode.all": "Aw o thir",
  "hashtag.column_settings.tag_mode.any": "Onie o thir",
  "hashtag.column_settings.tag_mode.none": "Naen o thir",
  "hashtag.column_settings.tag_toggle": "Pit in mair hashtags fir this column",
  "hashtag.follow": "Follae hashtag",
  "hashtag.unfollow": "Unfollae hashtag",
  "home.column_settings.show_reblogs": "Shaw boosts",
  "home.column_settings.show_replies": "Shaw replies",
  "home.hide_announcements": "Hide annooncements",
  "home.show_announcements": "Shaw annooncements",
  "interaction_modal.on_another_server": "On a different server",
  "interaction_modal.on_this_server": "On this server",
  "intervals.full.days": "{number, plural, one {# day} other {# days}}",
  "intervals.full.hours": "{number, plural, one {# oor} other {# oors}}",
  "intervals.full.minutes": "{number, plural, one {# minute} other {# minties}}",
  "keyboard_shortcuts.back": "Awa back",
  "keyboard_shortcuts.blocked": "Open dingied uisers list",
  "keyboard_shortcuts.boost": "Heeze post",
  "keyboard_shortcuts.column": "Focus column",
  "keyboard_shortcuts.compose": "Focus compose text area",
  "keyboard_shortcuts.description": "Description",
  "keyboard_shortcuts.down": "Muive doon in the list",
  "keyboard_shortcuts.enter": "Open post",
  "keyboard_shortcuts.federated": "Open federatit timeline",
  "keyboard_shortcuts.heading": "Keyboord shortcuts",
  "keyboard_shortcuts.home": "Open hame timeline",
  "keyboard_shortcuts.hotkey": "Hetkey",
  "keyboard_shortcuts.legend": "Display this legend",
  "keyboard_shortcuts.local": "Open local timeline",
  "keyboard_shortcuts.mention": "Menshie author",
  "keyboard_shortcuts.muted": "Open wheesht uisers list",
  "keyboard_shortcuts.my_profile": "Open yer profile",
  "keyboard_shortcuts.notifications": "Open notes column",
  "keyboard_shortcuts.open_media": "Open media",
  "keyboard_shortcuts.pinned": "Open preenit posts list",
  "keyboard_shortcuts.profile": "Open author's profile",
  "keyboard_shortcuts.reply": "Reply tae post",
  "keyboard_shortcuts.requests": "Open follae requests list",
  "keyboard_shortcuts.search": "Focus seirch baur",
  "keyboard_shortcuts.spoilers": "Shaw/hide CW field",
  "keyboard_shortcuts.start": "Open “get stertit” column",
  "keyboard_shortcuts.toggle_hidden": "Show/hide text ahin CW",
  "keyboard_shortcuts.toggle_sensitivity": "Show/hide media",
  "keyboard_shortcuts.toot": "Stert a new post",
  "keyboard_shortcuts.unfocus": "Unfocus scrieve textarea/seirch",
  "keyboard_shortcuts.up": "Muive up in the list",
  "lightbox.close": "Shut",
  "lightbox.next": "Neist",
  "lightbox.previous": "Last ane",
  "limited_account_hint.action": "Shaw profile onieweys",
  "limited_account_hint.title": "This profile haes been planked bi the moderators o {domain}.",
  "lists.delete": "Delete list",
  "lists.edit": "Edit list",
  "lists.replies_policy.followed": "Onie follaed uiser",
  "lists.replies_policy.list": "Memmers o the list",
  "lists.replies_policy.none": "Naebody",
  "load_pending": "{count, plural, one {# new item} other {# new items}}",
  "moved_to_account_banner.text": "Yer accoont {disabledAccount} is disabilt the noo acause ye flittit tae {movedToAccount}.",
  "navigation_bar.about": "Aboot",
  "navigation_bar.blocks": "Dingied uisers",
  "navigation_bar.bookmarks": "Buikmairks",
  "navigation_bar.domain_blocks": "Dingied domains",
  "navigation_bar.filters": "Wheesht wirds",
  "navigation_bar.follow_requests": "Follae requests",
  "navigation_bar.follows_and_followers": "Follaes an follaers",
  "navigation_bar.lists": "Leets",
  "navigation_bar.logout": "Logoot",
  "navigation_bar.mutes": "Wheesht uisers",
  "navigation_bar.preferences": "Preferences",
  "navigation_bar.search": "Seirch",
  "not_signed_in_indicator.not_signed_in": "Ye'r needin tae sign in fir tae access this resoorce.",
  "notification.admin.report": "{name} reportit {target}",
  "notification.admin.sign_up": "{name} signed up",
  "notification.follow": "{name} follaed ye",
  "notification.follow_request": "{name} is wantin tae follae ye",
  "notification.own_poll": "Yer poll is duin",
  "notification.reblog": "{name} heezed yer post",
  "notification.status": "{name} juist postit",
  "notification.update": "{name} editit a post",
  "notifications.clear": "Claer yer notes",
  "notifications.clear_confirmation": "Ye shaire thit ye'r wantin tae claer yer notes fir ever?",
  "notifications.column_settings.admin.report": "New reports:",
  "notifications.column_settings.admin.sign_up": "New sign-ups:",
  "notifications.column_settings.alert": "Desktap notes",
  "notifications.column_settings.follow": "New follaers:",
  "notifications.column_settings.follow_request": "New follae requests:",
  "notifications.column_settings.mention": "Menshies:",
  "notifications.column_settings.poll": "Poll results:",
  "notifications.column_settings.push": "Push notes",
  "notifications.column_settings.reblog": "Heezes:",
  "notifications.column_settings.show": "Shaw in column",
  "notifications.column_settings.sound": "Pley soond",
  "notifications.column_settings.status": "New posts:",
  "notifications.column_settings.unread_notifications.category": "Notes no read",
  "notifications.column_settings.unread_notifications.highlight": "Heichlicht notes no read",
  "notifications.column_settings.update": "Edits:",
  "notifications.filter.all": "Aw",
  "notifications.filter.boosts": "Heezes",
  "notifications.filter.follows": "Follaes",
  "notifications.filter.mentions": "Menshies",
  "notifications.filter.polls": "Poll results",
  "notifications.filter.statuses": "Updates fae fowk thit ye follae",
  "notifications.grant_permission": "Gie permission.",
  "notifications.group": "{count} notes",
  "notifications.mark_as_read": "Mairk ilka note as read",
  "notifications.permission_denied": "Desktap notes urnae available doon tae denied brooser permissions requests aforehaun",
  "notifications.permission_denied_alert": "Desktap notes cannae be turnt on, as brooser permission haes been denied aforehaun",
  "notifications.permission_required": "Desktap notes urnae available acause the needit permission haesnae been gien.",
  "notifications_permission_banner.enable": "Turn on desktap notes",
  "notifications_permission_banner.how_to_control": "Fir tae get notes whan Mastodon isnae open, turn on desktap notes. Ye kin pick exactly whit types o interactions gie ye desktap notes throu the {icon} button abuin ance they'r turnt on.",
  "notifications_permission_banner.title": "Dinnae miss a hing",
  "picture_in_picture.restore": "Pit it back",
  "poll.closed": "Shut",
  "poll.refresh": "Refresh",
  "poll.total_people": "{count, plural, one {# fowk} other {# fowk}}",
  "poll.total_votes": "{count, plural, one {# vote} other {# votes}}",
  "poll.vote": "Vote",
  "poll.voted": "Ye votit fir this answer",
  "poll.votes": "{votes, plural, one {# vote} other {# votes}}",
  "poll_button.add_poll": "Dae a poll",
  "poll_button.remove_poll": "Tak doon poll",
  "privacy.change": "Chynge post privacy",
  "privacy.public.short": "Public",
  "privacy_policy.last_updated": "Last updatit {date}",
  "privacy_policy.title": "Privacy Policy",
  "refresh": "Refresh",
  "relative_time.days": "{number}t",
  "relative_time.full.days": "{number, plural, one {# day} other {# days}} syne",
  "relative_time.full.hours": "{number, plural, one {# oor} other {# oors}} syne",
  "relative_time.full.just_now": "the noo",
  "relative_time.full.minutes": "{number, plural, one {# minute} other {# minties}} syne",
  "relative_time.full.seconds": "{number, plural, one {# saicont} other {# saiconts}} syne",
  "relative_time.hours": "{number}o",
  "relative_time.just_now": "noo",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "the day",
  "reply_indicator.cancel": "Cancel",
  "report.block": "Dingie",
  "report.block_explanation": "Ye'll no see their posts. They wullnae be able tae see your posts or follae ye. They wull be able tae tell thit they're dingied.",
  "report.categories.other": "Ither",
  "report.categories.spam": "Guff",
  "report.categories.violation": "Content breks ae or mair server rules",
  "report.category.subtitle": "Pick the best match",
  "report.category.title": "Tell us whit's gaun on wi this {type}",
  "report.category.title_account": "profile",
  "report.category.title_status": "post",
  "report.close": "Duin",
  "report.comment.title": "There ocht else thit ye hink we shuid ken?",
  "report.forward": "Forret tae {target}",
  "report.forward_hint": "The accoont is fae anither server. Sen an anonymized copy o the report tae there tae?",
  "report.mute": "Wheesht",
  "report.mute_explanation": "Ye wullnae see theirposts. They kin follae ye stull an see yer posts an wullnae ken thit they'r wheesht.",
  "report.next": "Neist",
  "report.placeholder": "Mair comments",
  "report.reasons.dislike": "A dinnae like it",
  "report.reasons.dislike_description": "It's no somehin thit ye want tae see",
  "report.reasons.other": "It's anither hing",
  "report.reasons.other_description": "The maitter disnae fir intae ither caitegories",
  "report.reasons.spam": "It's mince",
  "report.reasons.spam_description": "Fly links, fake engagement, or repetitive replies",
  "report.reasons.violation": "It breks server rules",
  "report.reasons.violation_description": "Ke ken thit it breks specific rules",
  "report.rules.subtitle": "Puck aw thit apply",
  "report.rules.title": "Whit rules is bein broke?",
  "report.statuses.subtitle": "Pick aw thit apply",
  "report.statuses.title": "Is there onie posts thit back up this report?",
  "report.submit": "Pit in",
  "report.target": "Reportin {target}",
  "report.thanks.take_action": "Here yer options fir pickin whit ye see on Mastodon:",
  "report.thanks.take_action_actionable": "Whilst we'r luikin ower this, ye kin tak steps aginst @{name}:",
  "report.thanks.title": "Ye dinnae want tae see this?",
  "report.thanks.title_actionable": "Ta fir reportin, we'll tak a luik intae this.",
  "report.unfollow": "Unfollae @{name}",
  "report.unfollow_explanation": "Ye'r follaein this accoont. Tae stap seein their post in yer hame feed onie mair, unfollae them.",
  "report_notification.attached_statuses": "{count, plural, one {{count} post} other {{count} posts}} attached",
  "report_notification.categories.other": "Ither",
  "report_notification.categories.spam": "Mince",
  "report_notification.categories.violation": "Rule violation",
  "report_notification.open": "Open report",
  "search.placeholder": "Seirch",
  "search.search_or_paste": "Seirch or paste URL",
  "search_results.all": "Aw",
  "search_results.hashtags": "Hashtags",
  "search_results.statuses": "Posts",
  "server_banner.about_active_users": "Fowk uisin this server in the last 30 days (Monthly Active Uisers)",
  "server_banner.active_users": "active uisers",
  "server_banner.administered_by": "Administert bi:",
  "server_banner.server_stats": "Server stats:",
  "sign_in_banner.create_account": "Mak accoont",
  "sign_in_banner.sign_in": "Sign in",
  "status.admin_account": "Open moderation interface fir @{name}",
  "status.admin_status": "Open this post in the moderation interface",
  "status.block": "Dingie @{name}",
  "status.bookmark": "Buikmairk",
  "status.cancel_reblog_private": "Unheeze",
  "status.cannot_reblog": "This post cannae be heezed",
  "status.copy": "Copy link tae post",
  "status.delete": "Delete",
  "status.detailed_status": "Detailt conversation view",
  "status.edit": "Edit",
  "status.edited_x_times": "Editit {count, plural, one {{count} time} other {{count} times}}",
  "status.filter": "Filter this post",
  "status.history.created": "{name} creatit {date}",
  "status.history.edited": "{name} editit {date}",
  "status.load_more": "Load mair",
  "status.media_hidden": "Media planked",
  "status.mention": "Menshie @{name}",
  "status.more": "Mair",
  "status.mute": "Wheesht @{name}",
  "status.mute_conversation": "Wheesht conversation",
  "status.open": "Expand this post",
  "status.pin": "Preen tae profile",
  "status.read_more": "Read mair",
  "status.reblog": "Heeze",
  "status.reblogged_by": "{name} heezed",
  "status.reblogs.empty": "Naebody haes heezed this post yit. Whan somebody dis, they wull shaw up here.",
  "status.redraft": "Delete & re-dae",
  "status.remove_bookmark": "Tak doon buikmairk",
  "status.replied_to": "Replied tae {name}",
  "status.reply": "Reply",
  "status.replyAll": "Reply tae threid",
  "status.report": "Clype @{name}",
  "status.sensitive_warning": "Sensitive content",
  "status.share": "Shaire",
  "status.show_less_all": "Shaw less fir aw",
  "status.show_more_all": "Shaw mair fir aw",
  "status.show_original": "Shaw original",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {{attachmentCount} attachments}}",
  "status.translate": "Owerset",
  "status.translated_from_with": "Owerset fae {lang} uisin {provider}",
  "status.unmute_conversation": "Unwheesht conversation",
  "status.unpin": "Unpreen fae profile",
  "subscribed_languages.lead": "Ainly posts in the leids ye pick wull shaw on yer hame an list timelines efter the chynge. Pick naen fir tae get posts in aw leids.",
  "subscribed_languages.save": "Save chynges",
  "subscribed_languages.target": "Chynge subscribed leids fir {target}",
  "tabs_bar.home": "Hame",
  "tabs_bar.notifications": "Notes",
  "time_remaining.days": "{number, plural, one {# day} other {# days}} left",
  "time_remaining.hours": "{number, plural, one {# oor} other {# oors}} left",
  "time_remaining.minutes": "{number, plural, one {# minute} other {# minties}} left",
  "time_remaining.moments": "Moments remainin",
  "time_remaining.seconds": "{number, plural, one {# saicont} other {# saiconts}} left",
  "trends.counter_by_accounts": "{count, plural, one {{counter} body} other {{counter} fowk}} in the past {days, plural, one {day} other {{days} days}}",
  "trends.trending_now": "Trendin noo",
  "ui.beforeunload": "Yer draft wull be lost if ye lea Mastodon.",
  "units.short.billion": "{count}B",
  "units.short.million": "{count}M",
  "units.short.thousand": "{count}K",
  "upload_area.title": "Drag & drap fir tae upload",
  "upload_button.label": "Add images, a video or a audio file",
  "upload_error.limit": "File upload limit exceedit.",
  "upload_error.poll": "File upload isnae allooed wi polls.",
  "upload_form.edit": "Edit",
  "upload_progress.label": "Uploadin...",
  "upload_progress.processing": "Processin…",
  "video.close": "Shut video",
  "video.download": "Doonload file",
  "video.exit_fullscreen": "Lea fu-screen",
  "video.expand": "Expand video",
  "video.fullscreen": "Fu-screen",
  "video.hide": "Plank video",
  "video.pause": "Pause",
  "video.play": "Pley"
}
